import { t } from "../../../../helpers/locale";
import { WMCoreParts } from "../../../../types/scheduling/weekend";

export interface UseOverlappingWMAssignmentsProps {
  assigneeId: number;
  partType: WMCoreParts;
  wtConductorId?: number;
  speakerId?: number;
  outgoingSpeakerIds?: number[];
}

export function useOverlappingWMAssignments({
  assigneeId,
  partType,
  wtConductorId,
  speakerId,
  outgoingSpeakerIds = [],
}: UseOverlappingWMAssignmentsProps): string | undefined {
  if (!assigneeId) return undefined;

  // Someone with an incoming or outgoing speaking assignment should show a conflict if they have any other assignment
  if (speakerId === assigneeId) {
    return t("schedules.weekend.speaker.0");
  }

  if (outgoingSpeakerIds.includes(assigneeId)) {
    return t("schedules.weekend.outgoing");
  }

  // If the WT conductor has any other weekend assignment besides hospitality, show it as a conflict
  if (wtConductorId === assigneeId && partType !== WMCoreParts.WTConductor && partType !== WMCoreParts.Host) {
    return t("schedules.weekend.wt-conductor");
  }

  return undefined;
}
